import React, { useState, useCallback } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app.tsx";
import { Landing } from "./landing.tsx";
import type { Lang } from "./i18n.ts";

// Load pre-built Tailwind CSS at runtime (avoid Bun bundler resolving it)
const link = document.createElement("link");
link.rel = "stylesheet";
link.href = "/style.css";
document.head.appendChild(link);

function Router() {
  const [page, setPage] = useState<"landing" | "app">(
    window.location.pathname === "/app" ? "app" : "landing",
  );
  const [lang, setLang] = useState<Lang>("pl");

  const goToApp = useCallback(() => {
    setPage("app");
    window.history.pushState({}, "", "/app");
    window.scrollTo(0, 0);
  }, []);

  const goToLanding = useCallback(() => {
    setPage("landing");
    window.history.pushState({}, "", "/");
    window.scrollTo(0, 0);
  }, []);

  // Handle browser back/forward
  React.useEffect(() => {
    const onPop = () => {
      setPage(window.location.pathname === "/app" ? "app" : "landing");
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  if (page === "app") {
    return <App lang={lang} setLang={setLang} onBack={goToLanding} />;
  }

  return <Landing lang={lang} setLang={setLang} onStart={goToApp} />;
}

const root = createRoot(document.getElementById("root")!);
root.render(<Router />);
